import * as React from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { Translate } from '../../../../../../../shared/LanguageService';
import { UploadVariant } from '../state/utils';

type ImageSizeSettingsNoticeProps = {
    variant: UploadVariant;
    size: number | null | undefined;
    dpi: number | null | undefined;
};

function displayValue(value: number | null | undefined): string {
    return value == null ? 'N/A' : String(value);
}

export function ImageSizeSettingsNotice({ variant, size, dpi }: ImageSizeSettingsNoticeProps) {
    let isNormal = variant === UploadVariant.Normal;

    return (
        <Alert severity={isNormal ? 'warning' : 'info'} icon={false} sx={{ fontSize: '14px' }}>
            <AlertTitle sx={{ fontSize: '16px' }}>
                {Translate(
                    isNormal
                        ? 'image-processing/edited/upload/image-size/settings/normal/title'
                        : 'image-processing/edited/upload/image-size/settings/high/title'
                )}
            </AlertTitle>
            {Translate('image-processing/edited/upload/image-size/settings/size', {
                value: displayValue(size)
            })}
            <br />
            {Translate('image-processing/edited/upload/image-size/settings/dpi', {
                value: displayValue(dpi)
            })}
        </Alert>
    );
}
